import { render } from "./Publish.vue?vue&type=template&id=28fed612"
import script from "./Publish.vue?vue&type=script&lang=js"
export * from "./Publish.vue?vue&type=script&lang=js"

import "./Publish.vue?vue&type=style&index=0&id=28fed612&lang=css"
script.render = render

export default script